export class SimpleQuestionAnswer {
    constructor(public question: number, public shortAnswer: string) {}
}

export class SimpleExerciseAnswer {
    constructor(public exercise: number, public questionAnswer: SimpleQuestionAnswer) {}
}

export class SimpleCardAnswers {
    constructor(public card: number, public exerciseAnswers: Array<SimpleExerciseAnswer>) {}
}
